export default "__VITE_ASSET__Osvajl0j__"